const meta = {
  'import-grafana-dashboards': 'Import Grafana dashboards',
  'classic-panels': 'Panels',
};

export default meta;
